'use client';

import { Icon } from '@bazaar-marketplace/assets';
import SvgTon from '@bazaar-marketplace/assets/ton';
import { match } from 'ts-pattern';
import { useTranslations } from 'next-intl';
import { TgStarAmount } from '~/components/icons/tg-star-icon';

import { Button } from '~/components/ui/button';

export type SaleButtonStatus = 'active' | 'ended' | 'sold-out' | 'soon';

interface SaleBuyButtonProps {
  status: SaleButtonStatus;
  starPricePerPack: number | string | null;
  tonPricePerPack: number | string | null;
  onClick: () => void;
}

export const SaleBuyButton = ({ status, starPricePerPack, tonPricePerPack, onClick }: SaleBuyButtonProps) => {
  const t = useTranslations('directSale');

  if (status === 'sold-out' || status === 'ended') {
    const buttonText = match(status)
      .with('sold-out', () => t('soldOut'))
      .with('ended', () => t('ended'))
      .exhaustive();

    return (
      <Button className="rounded-full px-4 h-8 py-2 text-[12px] text-white cursor-default" disabled variant="gray">
        {buttonText}
      </Button>
    );
  }

  if (status === 'soon') {
    return (
      <Button className="rounded-full px-4 py-2 h-8 uppercase text-[12px] cursor-default" disabled variant="gray">
        <Icon name="loading-03" size={14} />
        {t('soon')}
      </Button>
    );
  }

  return (
    <Button
      className="rounded-full px-2.5 py-2 uppercase text-[12px] flex items-center"
      variant="rainbow"
      onClick={onClick}
    >
      <div className="flex items-center">
        {starPricePerPack != null ? <TgStarAmount amount={starPricePerPack} /> : null}
        {starPricePerPack != null && tonPricePerPack != null ? (
          <div className="border-r h-4 border-[#23262e40] ml-1.5 mr-1"></div>
        ) : null}
        {tonPricePerPack != null ? (
          <div className="flex gap-0.5">
            <SvgTon className="size-4 text-black" />
            {tonPricePerPack}
          </div>
        ) : null}
      </div>
    </Button>
  );
};
